import { render, staticRenderFns } from "./certifyQueryNew.vue?vue&type=template&id=ddb0e102"
import script from "./certifyQueryNew.vue?vue&type=script&lang=js"
export * from "./certifyQueryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports